import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { iconLock } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';

type Props = {
	disabled: boolean;
	loading: boolean;
	useDonationLanguage: boolean;
	onClick: () => void;
};

export function SubmitButton({ disabled, loading, useDonationLanguage, onClick }: Props): JSX.Element {
	const getSuffix = () => {
		return useDonationLanguage ? '_donation' : '';
	};

	return (
		<Flex sx={{ justifyContent: 'center' }} mb={16}>
			<Button
				aria-label="submit-button"
				data-qa="submit-payment-button"
				data-testid="dlocal-button"
				disabled={disabled}
				loading={loading}
				onClick={onClick}
				mode="icon+label"
				icon={iconLock}
				sx={{ width: ['100%', '50%'] }}
			>
				<Translate value={`corgi.co.promote.submit_button_label${getSuffix()}`} />
			</Button>
		</Flex>
	);
}
